import { render, staticRenderFns } from "./ExternalPayment.vue?vue&type=template&id=2364337e&scoped=true&"
import script from "./ExternalPayment.vue?vue&type=script&lang=js&"
export * from "./ExternalPayment.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPayment.vue?vue&type=style&index=0&id=2364337e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2364337e",
  null
  
)

export default component.exports